module.exports = __webpack_public_path__ + "static/pill-db59f34e967fa5a785c8ffd17183608b.png";